import { REST_ROUTES } from '@cdw-ae/routes-shared-api';
import { ROUTE_PARAMS } from '../route-params';

/**
 * User Collections controller route constants
 *
 * Maps to @Controller('user-collections')
 */
export const USER_COLLECTIONS_ROUTES = {
  // Standard REST routes
  ROOT: REST_ROUTES.ROOT,
  GET_BY_ID: REST_ROUTES.GET_BY_ID,

  // Nested resource routes
  ADD_USERS: `${ROUTE_PARAMS.ID}/users`,
  REMOVE_USER: `${ROUTE_PARAMS.ID}/users/${ROUTE_PARAMS.USER_ID}`,
  CAN_DELETE: `${ROUTE_PARAMS.ID}/can-delete`,

  // CSV validation and import
  VALIDATE_CSV: 'validate-csv',
  IMPORT_CSV: 'import-csv',

} as const;

/**
 * Type representing all possible user collection routes
 */
export type UserCollectionsRoute =
  (typeof USER_COLLECTIONS_ROUTES)[keyof typeof USER_COLLECTIONS_ROUTES];
